// React
import { memo, useEffect } from 'react'

// MUI
import Box from '@mui/material/Box';

// others
import { useDrag } from 'react-dnd'
import { getEmptyImage } from 'react-dnd-html5-backend'

import { DragItemTypes } from './DragItemTypes.jsx'

function getStyles(left, top, width, height, isDragging) {
    return {
        position: 'static',
        width:`75%`, 
        maxWidth:`${width}px`, 
        borderRadius: '5px',
        border:'1px solid', 
        borderColor:'primary.main',
        padding: '5px 15px',
        cursor: 'grab',
        // IE fallback: hide the real node using CSS when dragging
        // because IE will ignore our custom "empty image" drag preview.
        opacity: isDragging ? 0.5 : 1,
        // height: isDragging ? 0 : '',
    }
}

export const FlowPaletteBox = memo(function FlowPaletteBox(props) {
    const { id, title, nodeType, left, top, width, height, extension } = props
    const dragItemType = DragItemTypes.PALETTE_BOX
    const [{ isDragging }, drag, preview] = useDrag(
        () => ({
            type: dragItemType,
            item: { id, dragItemType, nodeType, left, top, width, height, title, extension },
            collect: (monitor) => ({
                isDragging: monitor.isDragging(),
            }),
        }),
        [id, left, top, width, height, title],
    )
    useEffect(() => {
        preview(getEmptyImage(), { captureDraggingState: true })
    }, [preview])

    return (
        <Box
            ref={drag}
            sx={getStyles(left, top, width, height, isDragging)}
            role="FlowPaletteBox"
        >
            <Box 
                sx={{
                    alignContent: 'center',
                    justifyContent: 'center'}}>
                {title}
            </Box>
        </Box>
    )
})

export default FlowPaletteBox;

